import * as tslib_1 from "tslib";
import { Component, Model, Prop, Vue } from "vue-property-decorator";
let H3InputNumber = class H3InputNumber extends Vue {
    constructor() {
        super(...arguments);
        this.focused = false;
    }
    get inputValue() {
        const val = typeof this.value === 'number' ? this.value.toString() : '';
        return val;
    }
    onFocus(evt) {
        this.focused = true;
        this.$emit('focus', evt);
    }
    onBlur(evt) {
        this.focused = false;
        this.$emit('blur', evt);
    }
    stepUp() {
        if (this.value !== null) {
            const val = this.value + this.step;
            this.$emit('change', val);
        }
    }
    stepDown() {
        if (this.value !== null) {
            const val = this.value - this.step;
            this.$emit('change', val);
        }
    }
    onChange(evt) {
        const inputVal = evt.target.value;
        var val = /^-?\d+(\.{1}\d*)?$/.test(inputVal) ? Number(inputVal) : null;
        if (val) {
            // 正数最大只能输入 13位
            let inter = inputVal.split('.');
            if (inter[0].length > 13) {
                inter[0] = inter[0].slice(0, 13);
                val = +inter.join('.');
                evt.target.value = val + '';
                console.log(val);
            }
        }
        this.$emit('change', val);
    }
};
tslib_1.__decorate([
    Prop({
        default: ''
    })
], H3InputNumber.prototype, "placeholder", void 0);
tslib_1.__decorate([
    Prop({
        default: false
    })
], H3InputNumber.prototype, "disabled", void 0);
tslib_1.__decorate([
    Model('change')
], H3InputNumber.prototype, "value", void 0);
tslib_1.__decorate([
    Prop({
        default: 1
    })
], H3InputNumber.prototype, "step", void 0);
H3InputNumber = tslib_1.__decorate([
    Component({
        name: "h3-input-number",
        components: {}
    })
], H3InputNumber);
export default H3InputNumber;
